export function scrollableAncestor(el: HTMLElement): HTMLElement | null
{
	let node: HTMLElement | null = el.parentElement;
	while (node && node !== document.body) {
		const overflow = getComputedStyle(node).overflowY;
		if (overflow === 'auto' || overflow === 'scroll') return node;
		node = node.parentElement;
	}
	return null;
}
